import {ResponseType} from '../../node.js';
import {MessageReceiver} from '../../common/channel.js';
import {Hiccup} from '../../restrictions/types.js';
import {IOGateway} from '../../../gateway';

export type OriginType = 'local' | 'cluster';
export type AddressType = OriginType | 'peer' | 'node';

export type PeerId = string;
export type RequestId = string;

export type Identity = {
    user?: string,
    application?: string
    [key: string]: unknown
}

export type Restrictions = Readonly<undefined | OriginType | Hiccup>;

export interface Source {
    type: AddressType
}

// if its a local peer, then it has a channel (receive function)
export interface LocalAddress extends Source {
    type: 'local'
    receive: MessageReceiver<IOGateway.Message<ResponseType | 'ping'>> | string | null
    endpoint: string
    host?: string
    auth?: (request: IOGateway.Auth.AuthenticationRequest) => Promise<IOGateway.Auth.AuthenticationSuccess>
}

// if its a remote peer, then it has a peer(-id)
export interface PeerAddress extends Source {
    type: 'peer'
    peer: PeerId
    node: string
}

// broadcast address
export interface ClusterAddress extends Source {
    type: 'cluster'
}

// unicast node address
export interface NodeAddress extends Source {
    type: 'node'
    node: string
}


export function isPeerAddress(source?: Source): source is PeerAddress {
    return source?.type === 'peer';
}

export function isNodeAddress(source?: Source): source is NodeAddress {
    return source?.type === 'node';
}

export function isClusterAddress(source?: Source): source is ClusterAddress {
    return source?.type === 'cluster';
}
